import Chartjs from '@stimulus-components/chartjs'
import { Chart } from 'chart.js'

const responsiveLayoutPaddingPlugin = {
  id: 'responsiveLayoutPadding',

  beforeLayout(chart) {
    const responsivePadding = chart.options.responsiveLayoutPadding
    if (!responsivePadding) return

    const right =
      chart.width >= responsivePadding.breakpoint
        ? responsivePadding.expanded
        : responsivePadding.compact

    chart.options.layout.padding.right = right
  },
}

const wrapCategoryLabelsPlugin = {
  id: 'wrapCategoryLabels',

  beforeUpdate(chart) {
    if (chart.options.plugins?.wrapCategoryLabels?.enabled !== true) return

    const xScale = chart.options.scales?.x
    if (!xScale) return

    xScale.ticks = {
      ...xScale.ticks,
      autoSkip: false,
      maxRotation: 0,
      minRotation: 0,
      callback(value) {
        const label =
          chart.data.datasets[0]?.data?.[value]?.label ||
          chart.scales.x?.getLabelForValue(value)
        return typeof label === 'string' ? label.split(/\s+/) : label
      },
    }
  },
}

Chart.register(wrapCategoryLabelsPlugin)
Chart.register(responsiveLayoutPaddingPlugin)

export default class extends Chartjs {}
